(() => {
  const selector = '[data-root="ProductGroup"] a.pg-product[data-option-value]';
  const productPriceCache = new Map();

  const getProductPrice = async (link) => {
    const url = new URL(link.href, window.location.origin);
    const endpoint = `${url.pathname}.js`;

    if (!productPriceCache.has(endpoint)) {
      productPriceCache.set(endpoint, fetch(endpoint)
        .then((response) => {
          if (!response.ok) throw new Error(`Unable to load ${endpoint}`);
          return response.json();
        })
        .then((product) => Number(product.price))
        .catch(() => 0));
    }

    return productPriceCache.get(endpoint);
  };

  const enhancePackGroup = async (group) => {
    if (group.dataset.mcPackEnhanced === 'true') return;

    const links = Array.from(group.querySelectorAll(selector));
    if (!links.length) return;
    group.dataset.mcPackEnhanced = 'true';

    links.sort((a, b) => {
      const aIsTwoPack = /2-?pack/i.test(a.dataset.optionValue || '');
      const bIsTwoPack = /2-?pack/i.test(b.dataset.optionValue || '');
      return Number(bIsTwoPack) - Number(aIsTwoPack);
    }).forEach((link) => link.parentElement?.appendChild(link));

    const onePack = links.find((link) => !/2-?pack/i.test(link.dataset.optionValue || ''));
    const twoPack = links.find((link) => /2-?pack/i.test(link.dataset.optionValue || ''));
    if (!onePack || !twoPack) return;

    const [onePackPrice, twoPackPrice] = await Promise.all([
      getProductPrice(onePack),
      getProductPrice(twoPack),
    ]);
    const discount = onePackPrice > 0 && twoPackPrice > 0
      ? Math.round((1 - (twoPackPrice / (onePackPrice * 2))) * 100)
      : 0;

    if (discount > 0 && !twoPack.querySelector('.mc-fd-pack-link__discount')) {
      const badge = document.createElement('span');
      badge.className = 'mc-fd-pack-link__discount';
      badge.textContent = `${discount}% OFF`;
      twoPack.appendChild(badge);
    }
  };

  const labelPackLinks = (root = document) => {
    root.querySelectorAll?.(selector).forEach((link) => {
      const handle = (link.dataset.optionValue || '').toLowerCase();
      const isTwoPack = handle.includes('2pack') || handle.includes('2-pack');
      const label = isTwoPack ? '2 Packs' : '1 Pack';

      link.classList.add('mc-fd-pack-link');
      link.setAttribute('aria-label', label);
      if (!link.querySelector('.mc-fd-pack-link__label')) {
        const text = document.createElement('span');
        text.className = 'mc-fd-pack-link__label';
        text.textContent = label;
        link.appendChild(text);
      }
    });

    const groups = [];
    if (root.matches?.('[data-root="ProductGroup"]')) groups.push(root);
    root.querySelectorAll?.('[data-root="ProductGroup"]').forEach((group) => groups.push(group));
    groups.forEach((group) => enhancePackGroup(group));
  };

  const start = () => {
    labelPackLinks();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) labelPackLinks(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
